var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLinkedinDark = function SvgLinkedinDark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 85 85"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Circle Black"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 42.5,
    r: 42.5,
    className: "Linkedin_dark_svg__cls-1"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Linkedin"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.31 34.36h9.87V66.1h-9.87Zm4.94-15.77a5.72 5.72 0 1 1-5.72 5.72 5.72 5.72 0 0 1 5.72-5.72M35.37 34.36h9.45v4.34H45a10.36 10.36 0 0 1 9.33-5.12c10 0 11.83 6.57 11.83 15.11V66.1h-9.9V50.67c0-3.68-.06-8.42-5.12-8.42s-5.92 4-5.92 8.15v15.7h-9.85Z",
    className: "Linkedin_dark_svg__cls-2"
  })))));
};
export default SvgLinkedinDark;